import React from 'react';
import styles from './TickerBand.module.css';

function TickerBand({ text }) {
  return (
    <div className={styles.ticker} aria-hidden="true">
      <div className={styles.track}>
        <span className={styles.copy}>{text}</span>
        <span className={styles.copy}>{text}</span>
      </div>
    </div>
  );
}

export default TickerBand;
